import {Box, Typography} from '@mui/material';

const DocEmpty = () => {
  return (
    <Box
      sx={{
        height: '80vh', // Match your invoice height
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          fontSize: 48,
          color: 'primary.main',
          mb: 2,
          opacity: 0.8,
        }}
      >
        {'○'}
      </Box>

      <Typography
        variant='h1'
        sx={{
          fontSize: 16,
          color: '#1A1A1B',
          letterSpacing: '2px',
          textTransform: 'uppercase',
        }}
      >
        {'No Document Found'}
      </Typography>

      <Typography
        sx={{
          mt: 3,
          fontSize: 12,
          fontWeight: 600,
          textTransform: 'uppercase',
          color: 'rgb(149, 156, 169)',
          letterSpacing: '1px',
        }}
      >
        {'There is no document to display at the moment.'}
      </Typography>
    </Box>
  );
};

DocEmpty.displayName = 'DocEmpty';

export default DocEmpty;
